<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="figma4">
        <clever-reiseziel [mode]="'home'" [type]="type()" [completion]="completion"></clever-reiseziel>
        @if(type() === 'pauschal') {
        <clever-airport [mode]="'home'"></clever-airport>
        } @else if(type() === 'hotelonly') {
        <clever-roomtype [mode]="'home'"></clever-roomtype>
        } @else if(type() === 'railtravel') {
        <clever-reil [mode]="'home'"></clever-reil>
        }
        @if(showDate()) {
        <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
            (selectValue)="selectValue($event)" [mode]="'home'" class="w300px"></clever-date>
        }
        <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"></clever-traveller>
        <button (click)="gotoZiel(true)" class="custombutton">
            <img src="../../../../assets/tvg/search.svg" alt="search" />
            <span>{{btntext()}}</span>
        </button>
    </div>

    <!-- <div class="quicksearchbar">

        <div class="frame1">
            <div class="quicksearchmenubtn"><img
                    src="../../../../assets/tvg/sunnybeach.svg" /><span>Pauschalreisen</span>
            </div>
            <div class="quicksearchmenubtn"><img src="../../../../assets/tvg/hotel.svg" /><span>Hotels</span></div>
            <div class="quicksearchmenubtn"><img src="../../../../assets/tvg/airplane.svg" /><span>Flüge</span></div>
            <div class="quicksearchmenubtn"><img src="../../../../assets/tvg/ship.svg" /><span>Kreuzfahrten</span></div>
        </div>
        <div class="frame2">
            <clever-reiseziel [mode]="'home'" [type]="local_type()" [completion]="completion"></clever-reiseziel>
            @if(local_type()=== 'pauschal') {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"
                [reisende]="filter?.reisendeResult"></clever-traveller>
            <button (click)="gotoZiel(true)" class="custombutton">
                <img src="../../../../assets/tvg/search.svg" />
                <span>{{btntext}}</span>
            </button>
        </div>
    </div> -->
    <!-- <div class="headercc1">
        @if(israiltravel) {
        <div [class.headercc2]="local_type()=== 'railtravel'" [class.headercc4]="local_type()!== 'railtravel'"
            (click)="setBahn()">
            <div>{{'Bahnreisen'}}</div>
        </div>
        } @else {
        <div [class.headercc2]="local_type()=== 'pauschal'" [class.headercc4]="local_type()!== 'pauschal'"
            (click)="setPauschal()">
            <div>{{'Pauschalreisen'}}</div>
        </div>
        }
        <div [class.headercc3]="local_type()!== 'hotelonly'" [class.headercc2]="local_type()=== 'hotelonly'" (click)="setHotelonly()">
            <div>{{'Hotels'}}</div>
        </div>
    </div> -->
    <!-- <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <clever-reiseziel [mode]="'home'" [type]="local_type()" class="w270p" [completion]="completion"></clever-reiseziel>
            @if(local_type()=== 'pauschal') {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            @if(local_type()=== 'railtravel') {
            <clever-reil [mode]="'home'"></clever-reil>
            }
            @if(local_type()=== 'hotelonly') {
            <clever-roomlocal_type()[mode]="'home'"></clever-roomtype>
            }
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-dauer [mode]="'home'"></clever-dauer>
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"
                [reisende]="filter?.reisendeResult"></clever-traveller>
            <button matTooltip="Mehr Filter" aria-label="Mehr Filter" (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel(true)" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div> -->
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <!-- <div class="headercc1mobile">
            @if(israiltravel) {
            <div [class.headercc2mobile]="local_type()=== 'pauschal'"
                [class.headercc4mobile]="local_type()!== 'pauschal'" (click)="setBahn()">
                <div>{{'Bahnreisen'}}</div>
            </div>
            } @else {
            <div [class.headercc2mobile]="local_type()=== 'pauschal'"
                [class.headercc4mobile]="local_type()!== 'pauschal'" (click)="setPauschal()">
                <div>{{'Pauschalreisen'}}</div>
            </div>
            }
            <div [class.headercc3mobile]="local_type()!== 'hotelonly'"
                [class.headercc2mobile]="local_type()=== 'hotelonly'" (click)="setHotelonly()">
                <div>{{'Hotels'}}</div>
            </div>
        </div> -->
        <div class="figma4_mobile">
            <clever-reiseziel [mode]="'home'" [type]="type()" [completion]="completion()"></clever-reiseziel>
            @if(type() === 'pauschal') {
            <clever-airport [mode]="'home'"></clever-airport>
            } @else if(type() === 'hotelonly') {
            <clever-roomtype [mode]="'home'"></clever-roomtype>
            } @else if(type() === 'railtravel') {
            <clever-reil [mode]="'home'"></clever-reil>
            }
            @if(showDate()) {
            <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
                (selectValue)="selectValue($event)" [mode]="'home'" class="w300px"></clever-date>
            }
            <clever-traveller [mode]="'home'" (sendRes)="resTraveler($event)"></clever-traveller>
            <button (click)="gotoZiel(true)" class="custombutton">
                <img src="../../../../assets/tvg/search.svg" alt="search" />
                <span>{{btntext()}}</span>
            </button>
        </div>
        <!-- <div class="tmp-extrafilter-wraper-mobile w100">
            <clever-reiseziel [mode]="'home'" [type]="local_type()" class="w100"
                [completion]="completion"></clever-reiseziel>
            <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w100"></clever-date>
            <div class="gr-btn-mobile w100">
                <ng-container *ngIf="local_type()=== 'pauschal'">
                    <clever-airport [mode]="'home'" class="w25"></clever-airport>
                </ng-container>
                <ng-container *ngIf="local_type()=== 'railtravel'">
                    <clever-reil [mode]="'home'" class="w25"></clever-reil>
                </ng-container>
                <ng-container *ngIf="local_type()=== 'hotelonly'">
                    <clever-roomtype [mode]="'home'" class="w25"></clever-roomtype>
                </ng-container>
                <clever-dauer [mode]="'home'" class="w50-mobile"></clever-dauer>
                <clever-traveller [mode]="'home'" class="w25" (sendRes)="resTraveler($event)"></clever-traveller>
            </div>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilterMobile"></ng-container>
            <button matTooltip="Mehr Filter" aria-label="Mehr Filter" class="tmp-mehrfilter-mobile"
                (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel(true)"
                matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext()}}</span>
            </button>
        </div> -->
    </div>
</ng-template>

<ng-template #nohomefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
    }
</ng-template>


<ng-template #nohomemodeMobile>
    @if(smallVersion()) {
    <div class="tmp-inputs-wrapper-nohome-mobile">
        <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
            <div class="m05 cc1">
                <span class="smallfilter-title">
                    <clever-reiseziel [mode]="'nohomesmall'" [type]="local_type()"
                        [completion]="completion"></clever-reiseziel>
                </span>
                <div class="smallfilter-body">
                    <span class="smallitem">
                        @if(showDate()) {
                        <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
                            (selectValue)="selectValue($event)" [mode]="'nohomesmall'"></clever-date> }|
                    </span>
                    <span class="smallitem">
                        <clever-dauer [mode]="'nohomesmall'"></clever-dauer> |
                    </span>
                    <span class="smallitem">
                        <clever-traveller [mode]="'nohomesmall'" (sendRes)="resTraveler($event)"></clever-traveller>
                        P |
                    </span>
                    <span class="smallitem">
                        @if(local_type()=== 'pauschal') {
                        <clever-airport [mode]="'nohomesmall'"></clever-airport>
                        }
                        @if(local_type()=== 'railtravel') {
                        <clever-reil [mode]="'nohomesmall'"></clever-reil>
                        }
                        @if(local_type()=== 'hotelonly') {
                        <clever-roomtype [mode]="'nohomesmall'"></clever-roomtype>
                        }
                    </span>
                </div>
            </div>
            <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
            </button>
        </div>
    </div>
    } @else {
    <div class="tmp-inputs-wrapper-nohome-mobile">
        <ng-container *ngTemplateOutlet="nohomefilterdesk">
        </ng-container>
    </div>
    }
</ng-template>
<!-- 
<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <ng-container *ngTemplateOutlet="switchbtn"></ng-container>
        <clever-reiseziel [mode]="'nohome'" [type]="local_type()" class="w100"
            [completion]="completion"></clever-reiseziel>
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        <ng-container *ngIf="local_type()=== 'pauschal'">
            <clever-airport [mode]="'nohome'" [norightborder]="false" [bottomleftradius]="false"
                class="w100"></clever-airport>
        </ng-container>
        <ng-container *ngIf="local_type()=== 'railtravel'">
            <clever-reil [mode]="'nohome'" class="w100"></clever-reil>
        </ng-container>
        <div class="tmp-custsection">
            <clever-dauer [mode]="'nohome'" class="w50"></clever-dauer>
            <clever-traveller [mode]="'nohome'" class="w50" (sendRes)="resTraveler($event)"></clever-traveller>
        </div>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel(false)" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template> -->

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <ng-container *ngTemplateOutlet="switchbtn"></ng-container>

        <clever-reiseziel [mode]="'nohome'" [type]="local_type()" class="w100"
            [completion]="completion"></clever-reiseziel>

        @if(showDate()) {
        <clever-date [start]="start()" [end]="end()" [mindauer]="mindauer()" [maxdauer]="maxdauer()"
            (selectValue)="selectValue($event)" [mode]="'nohome'" class="w100"></clever-date>
        }

        @if(local_type()=== 'pauschal') {
        <clever-airport [mode]="'nohome'" class="w100"></clever-airport>
        } @else if(type() === 'hotelonly') {
        <clever-roomtype class="w100" [mode]="'nohome'"></clever-roomtype>
        }

        @if(local_type()=== 'railtravel') {
        <clever-reil [mode]="'nohome'" class="w100"></clever-reil>
        }

        <clever-traveller [mode]="'nohome'" class="w100" (sendRes)="resTraveler($event)"></clever-traveller>

        <!-- <clever-dauer [mode]="'nohome'" class="w50"></clever-dauer> -->
        <button class="custombutton w100 " (click)="gotoZiel(false)" matRipple>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilterMobile>
    <clever-hotelextrafilter [mode]="'home'" [type]="local_type()" class="w100" (closeModal)="openclosemore()">
    </clever-hotelextrafilter>
</ng-template>

<ng-template #moreFilter>
    <clever-hotelextrafilter [mode]="'home'" [type]="local_type()" class="w100" (closeModal)="openclosemore()">
    </clever-hotelextrafilter>
</ng-template>

<ng-template #switchbtn>
    <div class="w100 switchwrp">
        <!-- @if(israiltravel) {
        <button class="switchbtn btl nbb" [class.activeType]="local_type()=== 'railtravel'"
            (click)="switchTo('railtravel')">{{'Bahnreisen'}}</button>
        } @else {
        <button class="switchbtn btl nbb" [class.activeType]="local_type()=== 'pauschal'"
            (click)="switchTo('pauschal')">{{'Pauschalreisen'}}</button>
        }
        <button class="switchbtn btr nbb" [class.activeType]="local_type()=== 'hotelonly'"
            (click)="switchTo('hotelonly')">{{'Nur Hotel'}}</button> -->
        @if(type() === 'railtravel') {
        <div class="quicksearchmenubtn" [class.quicksearchmenubtnactive]="local_type() === 'railtravel'"
            (click)="switchTo('railtravel')">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path
                    d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
            </svg>
            <span>Bahnreisen</span>
        </div>
        }@else {

        <div class="quicksearchmenubtn" [class.quicksearchmenubtnactive]="local_type() === 'pauschal'"
            (click)="switchTo('pauschal')">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="currentColor">
                <path
                    d="M12.4688 1.01562C12.5312 1.04688 12.5625 1.04688 12.5938 1.07812C12.7188 1.10938 12.8438 1.17188 12.9688 1.20312C16.2188 2.57812 18.125 5.85938 17.8438 9.23438C17.7812 9.82812 17.1562 10.1719 16.5938 9.98438L10.9062 7.89062L9.5 7.39062L3.8125 5.32812C3.25 5.10938 3 4.45312 3.34375 3.95312C5.34375 1.14062 9.0625 -0.171875 12.4688 1.01562ZM9 2.14062C7.5 2.32812 6.125 3.07812 5.09375 4.17188L7.21875 4.95312C7.6875 3.95312 8.28125 2.98438 9 2.14062ZM12.9062 7.01562C13.1875 6.01562 13.3125 4.95312 13.25 3.89062C13.2188 3.32812 12.875 2.82812 12.375 2.57812C12.2812 2.54688 12.1875 2.51562 12.0938 2.48438C12.0625 2.45312 12.0312 2.45312 12 2.45312C11.4375 2.26562 10.8125 2.42188 10.375 2.85938C9.65625 3.64062 9.0625 4.51562 8.65625 5.48438L12.9062 7.01562ZM14.3125 7.54688L16.375 8.29688C16.2812 6.82812 15.7188 5.42188 14.7812 4.32812C14.7812 5.42188 14.625 6.48438 14.3125 7.54688ZM17.25 14.9219C17.6562 14.9219 18 15.2656 18 15.6719C18 16.1094 17.6562 16.4219 17.25 16.4219H0.75C0.3125 16.4219 0 16.1094 0 15.6719C0 15.2656 0.3125 14.9219 0.75 14.9219H6.75L9.15625 8.32812L10.5625 8.82812L8.34375 14.9219H17.25Z"
                    fill="currentColor" />
            </svg>
            <span>Pauschalreisen</span>
        </div>
        }
        <div class="quicksearchmenubtn" [class.quicksearchmenubtnactive]="local_type() === 'hotelonly'"
            (click)="switchTo('hotelonly')">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.75 0.5H15.25C15.6562 0.5 16 0.84375 16 1.25C16 1.6875 15.6562 2 15.25 2H15V15H15.25C15.6562 15 16 15.3438 16 15.75C16 16.1875 15.6562 16.5 15.25 16.5H0.75C0.3125 16.5 0 16.1875 0 15.75C0 15.3438 0.3125 15 0.75 15H1V2H0.75C0.3125 2 0 1.6875 0 1.25C0 0.84375 0.3125 0.5 0.75 0.5ZM13.5 2H2.5V15H6.5V12.5H5.5C5.21875 12.5 4.96875 12.2812 5.03125 12.0312C5.25 10.5938 6.5 9.5 8 9.5C9.46875 9.5 10.7188 10.5938 10.9375 12.0312C11 12.2812 10.75 12.5 10.5 12.5H9.5V15H13.5V2ZM4.5 3.5H5.5C5.75 3.5 6 3.75 6 4V5C6 5.28125 5.75 5.5 5.5 5.5H4.5C4.21875 5.5 4 5.28125 4 5V4C4 3.75 4.21875 3.5 4.5 3.5ZM7 4C7 3.75 7.21875 3.5 7.5 3.5H8.5C8.75 3.5 9 3.75 9 4V5C9 5.28125 8.75 5.5 8.5 5.5H7.5C7.21875 5.5 7 5.28125 7 5V4ZM10.5 3.5H11.5C11.75 3.5 12 3.75 12 4V5C12 5.28125 11.75 5.5 11.5 5.5H10.5C10.2188 5.5 10 5.28125 10 5V4C10 3.75 10.2188 3.5 10.5 3.5ZM4 7C4 6.75 4.21875 6.5 4.5 6.5H5.5C5.75 6.5 6 6.75 6 7V8C6 8.28125 5.75 8.5 5.5 8.5H4.5C4.21875 8.5 4 8.28125 4 8V7ZM7.5 6.5H8.5C8.75 6.5 9 6.75 9 7V8C9 8.28125 8.75 8.5 8.5 8.5H7.5C7.21875 8.5 7 8.28125 7 8V7C7 6.75 7.21875 6.5 7.5 6.5ZM10 7C10 6.75 10.2188 6.5 10.5 6.5H11.5C11.75 6.5 12 6.75 12 7V8C12 8.28125 11.75 8.5 11.5 8.5H10.5C10.2188 8.5 10 8.28125 10 8V7Z"
                    fill="currentColor" />
            </svg>
            <span>Hotels</span>
        </div>
    </div>
</ng-template>